import React from 'react';
import './PokemonImageVs.css';



const PokemonImageVs = props => {

  const imageStyle = {
    background: `no-repeat url(http://www.pokestadium.com/sprites/xy/${props.name}.gif)`, 
    backgroundSize: 'contain', 
    backgroundPosition: 'center'
  }

  return (
    <div className="Opponent">
        <div className="image" style={imageStyle}></div>
	      <div className="name">{props.name}</div>
    </div>
  );
}

export default PokemonImageVs;
